import * as React from "react"
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom"
import { PageNotFound1 } from "@indeed/indeed-design-system-illustrations-hero"
import { ErrorBoundary } from "../common/components/error-boundary"
import { configSelector } from "../common/utils/config-slice"
import { useI18n } from "../common/utils/i18n-context"
import { useAppSelector } from "../common/utils/redux-helpers"
import { ErrorPage } from "../features/error-page/error-page"
import { ExplicitFeedbackPage, ExplicitFeedbackThanksPage, ExplicitFeedbackLimitPage } from "../features/explicit-feedback"
import { TestHubPage } from "../features/internal/test-hub-page"
import { PausePage } from "../features/pause-page"

export const I2aWebappRoutes: React.FC = () => {
    const config = useAppSelector(configSelector)
    const { gettext } = useI18n()

    return window.__showErrorPage ? (
        <ErrorPage />
    ) : (
        <BrowserRouter>
            <ErrorBoundary fallbackComponent={<ErrorPage />}>
                <Switch>
                    <Route path="/invitations/feedback/thanks">
                        <ExplicitFeedbackThanksPage />
                    </Route>
                    <Route path="/invitations/feedback/limit">
                        <ExplicitFeedbackLimitPage />
                    </Route>
                    <Route exact path="/invitations/feedback">
                        <ExplicitFeedbackPage />
                    </Route>
                    <Route exact path={config.pauseUrl}>
                        <PausePage />
                    </Route>
                    <Route exact path="/private/debug/test-hub">
                        {config.env !== "PRODUCTION" ? <TestHubPage /> : <ErrorPage />}
                    </Route>
                    <Route exact path={config.errorUrl}>
                        <ErrorPage />
                    </Route>
                    <Route exact path="/error/404">
                        <ErrorPage
                            header={gettext("We can’t find this page")}
                            subHeader={gettext(
                                "It looks like this page doesn't exist or isn’t available right now. Check the URL for any typos or choose an option below."
                            )}
                            icon={<PageNotFound1 />}
                        />
                    </Route>
                    <Redirect to="/error/404" />
                </Switch>
            </ErrorBoundary>
        </BrowserRouter>
    )
}
